exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sourceCode[data-v-4defd8f0]{padding:0 15px;display:grid;-ms-flex-line-pack:center;align-content:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-left:1px solid #232323;background:#232323;color:#fff;font-size:18px}#sourceCode[data-v-4defd8f0],#sourceCode span[data-v-4defd8f0]{font-family:monospace}#sourceCode .image[data-v-4defd8f0],#sourceCode span .image[data-v-4defd8f0]{width:30px}", ""]);

// exports
